import { Bindings, FormControl, Input, RichEditor } from "components"
import { DISCOUNT_TYPES } from "lib/globals"
import React, { Fragment } from "react"

export default function Discount ({ context, index, currency, validationErrors, campaign, styles }) {
    return (
        <Fragment>
            <FormControl
                label="Discount"
                className={styles.input}
                error={
                    validationErrors[
                    `settings.add_to_unlock.goals.${index}.discount.reward`
                    ]
                }
            >
                <Input
                    type="number"
                    BindToContext={[
                        context,
                        `settings.add_to_unlock.goals.${index}.discount.reward`
                    ]}
                    min="0"
                    max={
                        campaign.settings.add_to_unlock.goals[index].discount.type ===
                            "percentage"
                            ? 100
                            : undefined
                    }
                    withDropdown={{
                        BindToContext: [
                            context,
                            `settings.add_to_unlock.goals.${index}.discount.type`
                        ],
                        options: DISCOUNT_TYPES(currency)
                    }}
                />
            </FormControl>
            <FormControl
                label="text before hitting the goal"
                info="We recommend using emoji's to draw attention"
                // error={validationErrors['settings.add_to_unlock.discount.before']}
                isSingleCol
            >
                <RichEditor
                    imageEmoji={true}
                    BindToContext={[
                        context,
                        `settings.add_to_unlock.goals.${index}.discount.before`
                    ]}
                    placeholder="add {{amount}} to unlock {{reward}} off"
                // hasError={!!validationErrors['settings.add_to_unlock.discount.before']}
                />
                <Bindings />
            </FormControl>
            <FormControl
                label="text after hitting the goal"
                info="We recommend using emoji's to draw attention. (You can leave this blank.)"
                // error={validationErrors['settings.add_to_unlock.discount.after']}
                isSingleCol
            >
                <RichEditor
                    imageEmoji={true}
                    // onFocus={() => setShowATUAfterText(true)}
                    // onBlur={() => setShowATUAfterText(false)}
                    // hasError={!!validationErrors['settings.add_to_unlock.discount.after']}
                    // BindToContext={[context, 'settings.add_to_unlock.discount.after']}
                    BindToContext={[
                        context,
                        `settings.add_to_unlock.goals.${index}.discount.after`
                    ]}
                    placeholder="you've unlocked {{reward}} off"
                />
                <Bindings />
            </FormControl>
        </Fragment>
    )
}